import { formatStringWithUnderscore, toLower, upperCaseSpecificWords } from '../../helpers/common'
import { createJsonFromQueryString } from '../../helpers/url'

import { CHIP_COLORS } from '../../constants/other'
import {
  DV_360_PLATFORM,
  FACEBOOK_PLATFORM,
  GOOGLE_PLATFORM,
  TIKTOK_PLATFORM
} from '../../constants/selectLists/platformList'
import { objectiveUpperCaseWords } from '../../constants/campaigns'

export const getStatusTagColor = (status = '') => {
  switch (toLower(status)) {
    case 'active':
      return CHIP_COLORS.success
    default:
      return CHIP_COLORS.neutral
  }
}

export const getFormattedListItemObjective = (platform, objective) => {
  if (platform === GOOGLE_PLATFORM || platform === DV_360_PLATFORM || platform === TIKTOK_PLATFORM) {
    return upperCaseSpecificWords(formatStringWithUnderscore(objective.toLowerCase()), objectiveUpperCaseWords)
  } else if (platform === FACEBOOK_PLATFORM) {
    const cleanedObjective = objective.replace('outcome_', '').toLowerCase()
    return formatStringWithUnderscore(cleanedObjective)
  } else {
    return formatStringWithUnderscore(objective)
  }
}

export const getLoadOptionsHandler = ({ getOptionsService, params, formatOptions, limit = 100 }) => {
  return async (search, loadedOptions, { next }) => {
    try {
      const response = await getOptionsService({
        ...params,
        limit,
        ...(!!search && {
          search
        }),
        ...createJsonFromQueryString(`?${next?.split('?')[1]}`)
      })

      const newOptions = formatOptions(response.results)

      return {
        options: newOptions,
        hasMore: !!response.next,
        additional: {
          next: response.next
        }
      }
    } catch (error) {
      console.error('Error while loading options', error)

      return {
        options: [],
        hasMore: false,
        additional: {}
      }
    }
  }
}

export const getLoadOptionsHandlerCursorPagination = ({
  getOptionsService,
  params,
  formatOptions,
  limit = 100,
  allowFetchNext = true
}) => {
  return async (search, loadedOptions, { after }) => {
    try {
      const response = await getOptionsService({
        ...params,
        limit,
        ...(!!search && {
          search
        }),
        after
      })

      const newOptions = formatOptions(response.data)

      return {
        options: newOptions,
        hasMore: allowFetchNext ? !!response.paging?.next : false,
        additional: {
          after: response.paging?.cursors?.after || 0
        }
      }
    } catch (error) {
      console.error('Error while loading options', error)

      return {
        options: [],
        hasMore: false,
        additional: {}
      }
    }
  }
}
